module.exports = __webpack_public_path__ + "static/media/hall-CSE.ce93f496.svg";